import { Navigate, Route, Routes } from "react-router-dom";
import { AdminPage } from "./pages/AdminPage";
import { LoginPage } from "./pages/LoginPage";

/**
 * The route table for the whole bundle: the sign-in page and the admin
 * dashboard, both served from this one S3 origin behind one CloudFront
 * distribution. Everything that is not /login lands there, including the
 * bare root: there is nothing to serve at "/" itself.
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
